import React, { useEffect } from 'react';
import { useAuthStore } from '../stores/auth-store';
import { useStoreStore } from '../stores/store-store';
import { storeApi } from '../lib/api';

const StoreInitializer: React.FC = () => {
  const { token, isAuthenticated } = useAuthStore();
  const { availableStores, initializeStore, setLoading, setError } = useStoreStore();

  useEffect(() => {
    const fetchAndInitializeStores = async () => {
      // Only fetch if authenticated and no stores are loaded yet
      if (!isAuthenticated || !token || availableStores.length > 0) {
        return;
      }

      setLoading(true);
      setError(null);

      try {
        const response = await storeApi.getUserStores(token);
        
        if (!response.success) {
          throw new Error(response.message || 'Failed to fetch user stores');
        }

        const stores = response.data.stores || [];
        const defaultStoreId = response.data.default_store;
        
        if (stores.length === 0) {
          throw new Error('No stores available for this user');
        }

        // Initialize the store store with the fetched stores and default store
        initializeStore(stores, defaultStoreId);
        

      } catch (error) {
        console.error('Failed to initialize stores:', error);
        const errorMessage = error instanceof Error ? error.message : 'Failed to load stores';
        setError(errorMessage);
      } finally {
        setLoading(false);
      }
    };

    fetchAndInitializeStores();
  }, [isAuthenticated, token, availableStores.length, initializeStore, setLoading, setError]);

  // This component doesn't render anything
  return null;
};

export default StoreInitializer;
